import { IUnsubscribeType } from 'pages/Unsubscribe/pages';

import { ApiResponse, query } from './api';
import * as Q from './unsubscribe.query';

interface UnsubscribeApiInterface {
  postUnsubscribe(token: string, type: IUnsubscribeType): ApiResponse<{ success: boolean }>;
}

export const UnsubscribeApi: UnsubscribeApiInterface = {
  async postUnsubscribe(token: string, type: IUnsubscribeType) {
    const { postUnsubscribe } = await query(
      {
        query: Q.postUnsubscribeQuery,
        variables: { token, type },
        name: 'postUnsubscribe',
      },
      false
    );
    return { data: postUnsubscribe };
  },
};
